<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <div class="divide-y">
        <div class="pb-6 space-y-3">
            <text-field
                label="Title"
                name="portal_leads_title"
                type="text"
                v-model="portalContentAndDesignStore.leadsPageSettings.program_leads_page_title"
            >
            </text-field>
            <text-editor
                name="portal_leads_description"
                :text="portalContentAndDesignStore.leadsPageSettings.program_leads_page_description"
                @input="(newValue) => { portalContentAndDesignStore.leadsPageSettings.program_leads_page_description = newValue }"
            >
            </text-editor>

            <radio-group-inline
                label="Branding"
                name="program_leads_page_branding_type"
                v-model="portalContentAndDesignStore.leadsPageSettings.program_leads_page_branding_type"
                :options="[
                        { value: 'none', label: 'None'},
                        { value: 'symbol', label: 'Symbol'},
                        { value: 'logo', label: 'Logo'}
                    ]">
                <template #note>
                    Select which image to display alongside the program summary.
                </template>
            </radio-group-inline>
        </div>
        <div class="py-3">
            <div class="space-y-4">
                <toggle
                    size="default"
                    name="program_leads_include_signup_links"
                    v-model="portalContentAndDesignStore.leadsPageSettings.program_leads_include_signup_links"
                    title="Include links for sign-up and log-in"
                >
                    <template #description>
                        Display links for sign-up and log-in under the program description.
                    </template>
                </toggle>

                <toggle
                    size="default"
                    name="program_leads_include_additional_section"
                    v-model="portalContentAndDesignStore.leadsPageSettings.program_leads_include_additional_section"
                    title="Include additional section about lead submission"
                >
                    <template #description>
                        Display an additional description highlighting the commission structure or incentives to encourage lead submissions.
                    </template>

                    <template v-slot:when-on>
                        <div class="mt-4">
                            <text-editor
                                name="program_leads_page_additional_description"
                                :text="portalContentAndDesignStore.leadsPageSettings.program_leads_page_additional_description"
                                @input="(newValue) => {
                                    portalContentAndDesignStore.leadsPageSettings.program_leads_page_additional_description = newValue;
                                }"
                            >
                            </text-editor>
                        </div>
                    </template>
                </toggle>
            </div>
        </div>
    </div>
</template>
